import { useContext } from "react";
import { FormContextMA } from "../form-context";
import { Section, H2 } from "./common-components";
import {
  notificationMethodOptions,
  notificationTypeOptions,
} from "../../patient/clinical-services/service-steps/education/data";
import { formatDateToDD_MMM_YYYY } from "../../../helpers/functions";

export function NotificationOfService({ documentation: propDocumentation }) {
  const contextDocumentation = useContext(FormContextMA)?.documentation;
  const documentation = propDocumentation || contextDocumentation;

  const typeValue =
    notificationTypeOptions.find(
      (o) => o.value === (Array.isArray(documentation?.notificationType)
        ? documentation.notificationType[0]
        : documentation?.notificationType)
    )?.label ?? "";

  const methodValue =
    notificationMethodOptions.find(
      (o) => o.value === documentation?.methodOfNotification
    )?.label ?? "";

  const dateValue = documentation?.dateOfNotification
    ? formatDateToDD_MMM_YYYY(documentation.dateOfNotification)
    : "";

  // Prefer notificationInformations; if missing, attempt to fall back to referralInformations
  let provider = documentation?.notificationInformations
    ? documentation.notificationInformations[0]
    : null;

  // If notificationInformations is null/empty, and referralInformations exists,
  // some flows use "same" to indicate use of referral info — use that as a safe fallback
  if (!provider && (!documentation?.notificationInformations || documentation.notificationInformations === null) && Array.isArray(documentation?.referralInformations) && documentation.referralInformations.length > 0) {
    const notificationTypeIsSame = Array.isArray(documentation?.notificationType) && documentation.notificationType.includes("same");
    const referralTypeIndicatesPrimary = Array.isArray(documentation?.referralType) && documentation.referralType.includes("Primary Provider");
    const firstReferralIsPrimary = documentation.referralInformations[0]?.referralType === "Primary Provider";

    if (notificationTypeIsSame || referralTypeIndicatesPrimary || firstReferralIsPrimary) {
      provider = documentation.referralInformations[0];
    }
  }

  // Build provider name with primary ordering firstName, middleName, lastName
  const providerName = provider
    ? [provider.firstName, provider.middleName, provider.lastName]
        .filter((x) => x && x.trim())
        .join(" ") ||
      [provider.lastName, provider.firstName, provider.middleName]
        .filter((x) => x && x.trim())
        .join(" ")
    : "";

  const designation = provider?.designation || provider?.title || "";

  return (
    <Section className="space-y-[0.0833333in]">
      <div className="grid grid-cols-2 items-start w-full gap-2">
        <div>
          <H2>Notification of Service</H2>
        </div>

        <div className="text-xs flex items-center justify-start space-x-2">
          <div className="text-xs text-gray-800 whitespace-nowrap">Date of Notification</div>
          <div className="font-semibold whitespace-nowrap">{dateValue}</div>
        </div>
      </div>

      <div className="text-xs w-full grid grid-cols-1 sm:grid-cols-2 gap-4 items-start">
        <div>
          <div className="flex items-center space-x-2">
            <div className="text-xxs text-gray-800 whitespace-nowrap">Type</div>
            <div className="font-semibold">{typeValue}</div>
          </div>

          <div className="mt-2 flex items-center space-x-2">
            <div className="text-xxs text-gray-800 whitespace-nowrap">Name</div>
            <div className="font-semibold">{providerName}</div>
          </div>
        </div>

        <div>
          <div className="flex items-center space-x-2">
            <div className="text-xxs text-gray-600 whitespace-nowrap">Method of Notification</div>
            <div className="font-semibold">{methodValue}</div>
          </div>

          <div className="mt-2 flex items-center space-x-2">
            <div className="text-xxs text-gray-600 whitespace-nowrap">Designation</div>
            <div className="font-semibold">{designation}</div>
          </div>
        </div>
      </div>
    </Section>
  );
}
